import React, { useEffect, useState } from 'react';
import { Container, CircularProgress, Box, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import { useLocation } from 'react-router-dom';

const CheckoutContainer = styled(Container)(({ theme }) => ({
  minHeight: '100vh',
  background: '#f9f9f9',
  padding: theme.spacing(4),
}));

const CheckoutPage = () => {

    useEffect(() => {
        const storedData = sessionStorage.getItem('paymentUserData');
        if (storedData) {
          const userData = JSON.parse(storedData);
          const container = document.getElementById('klarna-checkout-container');
          if (container && userData.html_snippet) {
            container.innerHTML = userData.html_snippet;
            // Delay the script re-injection to let the container update
            setTimeout(() => {
              const scripts = container.getElementsByTagName('script');
              Array.from(scripts).forEach((oldScript) => {
                const newScript = document.createElement('script');
                Array.from(oldScript.attributes).forEach(attr => {
                  newScript.setAttribute(attr.name, attr.value);
                });
                if (oldScript.src) {
                  newScript.src = oldScript.src;
                } else {
                  newScript.text = oldScript.innerHTML;
                }
                oldScript.parentNode.replaceChild(newScript, oldScript);
              });
            }, 100); // Adjust the delay if needed
          }
        }
      }, []);      
    
      return (
        <CheckoutContainer>
          {/* The container for Klarna Checkout */}
          <div id="klarna-checkout-container"></div>
        </CheckoutContainer>
      );
    };    
export default CheckoutPage;
